// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__DMksw","article":"styles_article__dkcIe","title":"styles_title__SUY4Y","description":"styles_description__Sxzm0"};